import { render } from "@/components/pages/individualWorkSupport/requirement024/Requirement024.html?vue&type=template&id=514f5aaa&external"
import script from "@/components/pages/individualWorkSupport/requirement024/Requirement024.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement024/Requirement024.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__